export type DxReviewState = 'editing' | 'in_review' | 'approved';
export type DxReviewAction =
    'submit-for-review' | 'request-changes' | 'approve' | 'edit-and-approve' | 'hand-back';

export interface DxReviewHistoryEntry {
    at: string;
    by: string;
    byName: string;
    action: DxReviewAction;
    note?: string;
}

export interface DxReportReview {
    state: DxReviewState;
    reviewerNote: string | null;
    history: DxReviewHistoryEntry[];
}

export const DX_REPORT_SECTION_IDS = [
    'treatment-goals',
    'findings',
    'comments',
    'risks',
    'special-consent',
    'estimated-treatment-time',
    'orthopulse-recommendation'
] as const;

export type DxReportSectionId = (typeof DX_REPORT_SECTION_IDS)[number];

export interface TiptapDoc {
    type: 'doc';
    content: unknown[];
}

export interface DxReportSection {
    id: DxReportSectionId;
    title: string;
    tiptapJson: TiptapDoc;
}

export interface DxReportFeeDiscount {
    name: string;
    deltaCents: number;
}

// amountCents is the BILLED amount (the practice's effective/discounted
// price). listPriceCents/discounts are frozen at selection time for display.
export interface DxReportFeeLine {
    // The base product; versionId is the product_version the line is priced from.
    productId: string;
    versionId?: string;
    productName: string;
    amountCents: number;
    isOverridden: boolean;
    listPriceCents?: number;
    discounts?: DxReportFeeDiscount[];
}

export interface DxReportFees {
    caseProduct: DxReportFeeLine | null;
    addons: DxReportFeeLine[];
    recommendedPatientInvestmentCents: number;
    currency: 'USD';
    notes?: string;
}

export interface DxReportPatientInfo {
    patientName: string;
    dateOfBirth: string | null;
    age: number | null;
    doctorName: string;
    practice?: string;
    reportDate: string;
}

export type DxReportOrthopulseStatus = 'mandatory' | 'recommended' | 'not_needed';

export interface DxReportPayload {
    schemaVersion: 1;
    patientInfo: DxReportPatientInfo;
    sections: DxReportSection[];
    fees: DxReportFees;
    review?: DxReportReview;
    orthopulseStatus?: DxReportOrthopulseStatus;
}
